import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

export const freeTrialVerifySmsKey = "/free_trial/verify_sms";

export const freeTrialVerifySmsCacheKeys: AllRouteEndpoints[] = [freeTrialVerifySmsKey];
